import React, { useState } from "react";
import profile from "../assets/placeholder-image-600x400.jpg";
import default_profile_photo from "../assets/BCHportrait.svg";
import Button from "./Button.js";

const Card = (props) => {
  let i = 0;
  const [viewMoreLess, setViewMoreLess] = useState(false);

  const imgPath =
    props.data.photo !== undefined && props.data.photo.length > 0
      ? props.data.photo
      : default_profile_photo;

  function viewMore() {
    setViewMoreLess(true);
  }

  function viewLess() {
    setViewMoreLess(false);
  }
  return (
    <>
      <div id={props.id + "_" + i++} className="card_employee" style={props.data.id ? {} : { display: "none" }}>
        <div>
          <div className="card__info">
            <div className="person_name" style={props.data.name !== undefined && props.data.name.length > 0 ? {} : { display: "hidden" }}>
              {props.data.name}
            </div>
            <div className="person_id" style={props.data.id !== undefined && props.data.id.length > 0 ? {} : { display: "hidden" } }>
              {props.data.id}
            </div>
            <div className="person_title" style={props.data.title !== undefined && props.data.title.length > 0 ? {} : { display: "hidden" }}>
              {props.data.title}
            </div>
            <div className="person_department" style={props.data.department !== undefined && props.data.department.length > 0 ? {} : { display: "hidden" }}>
              {props.data.department}
            </div>
          </div>
          <div className="person_contact">
            <div className="person_phone" style={props.data.phone !== undefined && props.data.phone.length > 0 ? {} : { display: "none" }}>
              <a href={`tel:${props.data.phone}`}>
                <span>{props.data.phone}</span>
              </a>
            </div>
            <div className="person_email" style={props.data.email !== undefined && props.data.email.length > 0 ? {} : { display: "none" }}>
              <a href={`mailto:${props.data.email}`}>
                <span>{props.data.email}</span>
              </a>
            </div>
            <div className="person_address" style={props.data.address !== undefined && props.data.address.length > 0 ? {} : { display: "none" }}>
              <a href={"https://www.google.com/maps/place/" + props.data.address}>
                <span>{props.data.address}</span>
              </a>
            </div>
            <div className="person_pager" style={props.data.pager !== undefined && props.data.pager.length > 0 ? {} : { display: "none" }}>
              <span>{props.data.pager}</span>
            </div>
          </div>
        </div>
        <div className="person_photo">
          <img src={imgPath} alt={props.data.name} />
        </div>
      </div>

      <div id={props.id + "_" + i++} className="card_content" style={!props.data.id ? {} : { display: "none" }}>
        <div className="content_img" style={props.data.photo ? {} : { display: "none" }}>
          <img src={profile} alt="" />
        </div>
        <div className="content_content">
          <div className="content_subheader">H2 subheader</div>
          <div className="content_block">
            <div
              className={`content_string ${ viewMoreLess ? "view_more" : "view_less" } `}>
              {props.data.content}
            </div>
            <div onClick={(e) => viewMore(e)} className="content_more" style={!viewMoreLess ? {} : { display: "none" }}>
              {props.data.viewMore}
            </div>
            <div onClick={(e) => viewLess(e)} className="content_less" style={viewMoreLess ? {} : { display: "none" }}>
              {props.data.viewLess}
            </div>
          </div>
          <div className="content_button" style={props.data.buttonLabel && props.data.buttonLabel.length > 0 && props.data.buttonAction !== undefined && props.data.buttonAction !== null ? {} : { display: "none" }}>
            <Button styleName="button button--primary" defaultClick={(e) => props.data.buttonAction} id={props.id + "_components_" + i++} text={props.data.buttonLabel}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;